<template>
    <div>
        <h3>Order Reminder Notifications</h3>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="date" label="Date" width="180">
            </el-table-column>
            <el-table-column prop="name" label="Name" width="180">
            </el-table-column>
            <el-table-column prop="address" label="Address"> </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            notifications: [],
            tableData: [
                {
                    date: "2016-05-03",
                    name: "Tom",
                    address: "No. 189, Grove St, Los Angeles",
                },
                {
                    date: "2016-05-02",
                    name: "Tom",
                    address: "No. 189, Grove St, Los Angeles",
                },
                {
                    date: "2016-05-04",
                    name: "Tom",
                    address: "No. 189, Grove St, Los Angeles",
                },
                {
                    date: "2016-05-01",
                    name: "Tom",
                    address: "No. 189, Grove St, Los Angeles",
                },
            ],
        };
    },
    mounted() {
        this.getData();
    },
    computed: {
        //
    },
    methods: {
        getData() {
            axios
                .get(`/web-api/notification/order-reminder`)
                .then((response) => {
                    //console.log(response);
                });
        },
    },
};
</script>

<style scoped>
.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>
